import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import InclusionAssetEditFields from './InclusionAssetEditFields';

export interface InclusionAssetEditValue {
  category: string;
  categoryId?: string | null;
  currency?: string;
  isHidden: boolean;
  name: string;
  rrp?: number | null;
  type?: string;
  unit?: string;
}

interface Props {
  isCustom?: boolean;
  isSaving?: boolean;
  open: boolean;
  value: InclusionAssetEditValue;
  onChange: (nextValue: InclusionAssetEditValue) => void;
  onClose: () => void;
  onSave: () => void;
}

export default function InclusionAssetEditDialog({
  isCustom,
  isSaving,
  open,
  value,
  onChange,
  onClose,
  onSave,
}: Props) {
  const canSave = !!value.name.trim() && !!value.category.trim() && !!value.unit?.trim();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Edit Inclusion Asset</DialogTitle>
      <DialogContent dividers>
        <InclusionAssetEditFields isCustom={isCustom} open={open} value={value} onChange={onChange} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSave} disabled={isSaving || !canSave}>
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
